<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <v-row justify="center">
                    <v-dialog v-model="dialog" persistent max-width="400">
                        <v-card>
                            <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
                            <v-card-title class="text-h5">
                                Konfirmasi
                            </v-card-title>
                            <v-card-text style="min-height: 50px;">Apakah anda yakin isian anda sudah benar?</v-card-text>
                            <v-card-actions class="justify-content-center">
                                <v-spacer></v-spacer>
                                <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                                    Batal
                                </v-btn>
                                <v-btn :disabled="isLoading" color="indigo darken-4 white--text"
                                    @click="onCloseDialog(true)">
                                    <v-progress-circular v-if="isLoading" indeterminate size="16" width="2" class="mr-2"></v-progress-circular>
                                    {{ isLoading ? 'Loading...' : 'Simpan' }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-alert text color="grey darken-1" class="p-4 mt-3 rounded-lg " elevation="0" v-if="userData !== null">
                    <v-row style="line-height: 2rem;padding-left:20px;color: #000;">
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>Nama</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ userData.name || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>NIM</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ userData.no_induk || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>Email</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ userData.email || '-' }}</td>
                            </tr>
                        </v-col>
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>No. Hp</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ userData.no_hp || '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>IPK</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ userData.ipk || '-' }}</td>
                            </tr>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-alert text color="blue darken-1" class="p-4 mt-3 rounded-lg " elevation="0" v-if="userData == null">
                    <v-row style="line-height: 2rem;padding-left:20px;color: #000;">
                        <p class="mb-0">{{ this.$t('form_register_internship') }}</p>
                    </v-row>
                </v-alert>
                <v-stepper class="mt-2" v-model="step" vertical>
                    <v-stepper-step complete step="1" @click="stepChecker(1)" style="cursor: pointer;"
                        :complete="1 < stepActive">
                        {{ this.$t('registrations') }}
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-alert v-if="kp !== null && kp !== null && kp.level_aproval_sekarang == 3" border="left"
                            color="red lighten-2" dark>
                            <div>
                                <h6 class="text-body-1"><strong>Perlu perbaikan</strong></h6>
                                <p class="text-caption mb-1">Catatan: {{ kp.catatan }}</p>
                            </div>
                        </v-alert>
                        <v-alert dense type="info" class="rounded-lg"
                            v-if="(kp && kp.level_aproval_sekarang == 1) && (riwayat && riwayat[0].kode_status == 'SBD')"
                            border="left" color="orange">
                            <div>
                                <h6 class="text-body-1 mb-0"><strong>Silakan lakukan pendaftaran ulang</strong></h6>
                                <p class="text-caption mb-1">Ubah perusahaan yang sekarang dengan perusahaan baru!</p>
                            </div>
                        </v-alert>
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <v-form ref="form1" v-model="register" lazy-validation>
                                    <h6 class="text-body-1 pb-5 indigo--text text--darken-4">{{ this.$t('fill_in_the_form')
                                    }}<v-icon class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-menu ref="datePicker1" v-model="datePicker1" :close-on-content-click="false"
                                                :return-value.sync="step1Form.tanggal_rencana_mulai_kp"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="format_tanggal_rencana_mulai_kp"
                                                        :rules="$rules.required" append-icon="mdi-calendar" readonly
                                                        v-bind="attrs" v-on="on">
                                                        <template #label>
                                                            {{ labelStep1.tanggal_rencana_mulai_kp }}<span
                                                                class="red--text"><strong>*
                                                                </strong></span>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                    v-model="step1Form.tanggal_rencana_mulai_kp" no-title scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="datePicker1 = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text color="primary"
                                                        @click="$refs.datePicker1.save(step1Form.tanggal_rencana_mulai_kp)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-menu ref="datePicker1b" v-model="datePicker1b"
                                                :close-on-content-click="false"
                                                :return-value.sync="step1Form.tanggal_rencana_selesai_kp"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="format_tanggal_rencana_selesai_kp"
                                                        label="Rencana selesai kp" :rules="$rules.required"
                                                        append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                                        <template #label>
                                                            {{ labelStep1.tanggal_rencana_selesai_kp }}<span
                                                                class="red--text"><strong>*
                                                                </strong></span>
                                                        </template></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                    v-model="step1Form.tanggal_rencana_selesai_kp" no-title scrollable
                                                    :min="step1Form.tanggal_rencana_mulai_kp">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="datePicker1 = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text color="primary"
                                                        @click="$refs.datePicker1b.save(step1Form.tanggal_rencana_selesai_kp)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col cols="12" sm="12" md="12">
                                            <v-autocomplete item-text="matakuliah" @blur="onBlurMatakuliah($event)"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                hide-no-data deletable-chips v-model="kuliah_prasyarat"
                                                :items="master_kuliah_prasyarat" @keydown="onKeydown($event)"
                                                :search-input.sync="input" chips @change="onChangeMatakulah($event)"
                                                small-chips multiple filled background-color="white" return-object>
                                                <template #label>
                                                    <span class="mb-3">{{ labelStep1.kuliah_prasyarat }}</span>
                                                </template></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" v-if="$isFTI">
                                            <v-text-field filled background-color="white" :readonly="true"
                                                :value="user.email" :rules="$rules.required" required>
                                                <template #label>
                                                    Email<span class="red--text"><strong>* </strong></span>
                                                </template></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="$isFTI">
                                            <v-text-field filled background-color="white" type="number" counter="15"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                v-model="step1Form.no_hp" :rules="$rules.required_phone_number" required>
                                                <template #label>
                                                    No. Hp/Whatsapp<span class="red--text"><strong>* </strong></span>
                                                </template></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" v-if="$isFTI">
                                            <v-text-field filled background-color="white" placeholder="contoh: 3.7"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                v-model="step1Form.ipk" :rules="$rules.required_ipk" required>
                                                <template #label>
                                                    IPK<span class="red--text"><strong>* </strong></span>
                                                </template></v-text-field>
                                        </v-col> <v-col cols="12" md="6" v-if="$isFTI">
                                            <v-text-field filled background-color="white"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                v-model="step1Form.sks" :rules="$rules.required" required>
                                                <template #label>
                                                    SKS Ditempuh<span class="red--text"><strong>* </strong></span>
                                                </template></v-text-field>
                                        </v-col>
                                        <!-- Kategori perusahaan -->
                                        <v-col cols="12" md="6">
                                            <v-select class="pb-0" :items="selectOptions.company_type" :item-text="'name'" :item-value="'id'" label="Kategori perusahaan" v-model="step1Form.company_type_id" solo v-if="$isFTSP"></v-select>
                                            <v-select class="pb-0" :items="selectOptions.company_topics" :item-text="'name'" :item-value="'id'" label="Bidang topik perusahaan" v-model="step1Form.company_topic_id" solo v-if="$isFTSP"></v-select>
                                            <v-text-field filled background-color="white"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                v-model="step1Form.perusahaan_tujuan" :rules="$rules.required" required>
                                                <template #label>
                                                    {{ labelStep1.perusahaan_tujuan }}<span class="red--text"><strong>*
                                                        </strong></span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-textarea filled background-color="white"
                                                :readonly="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                v-model="step1Form.alamat_perusahaan" :rules="$rules.required"
                                                label="Alamat perusahaan">
                                                <template #label>
                                                    {{ labelStep1.alamat_perusahaan }}<span class="red--text"><strong>*
                                                        </strong></span>
                                                </template></v-textarea>
                                        </v-col>
                                        
                                    </v-row>
                                    <v-divider class="indigo--text mb-0"></v-divider>
                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-card elevation="0" class="rounded-xl" height="100%">
                                                <v-card-title
                                                    class="text-body-1 indigo--text text--darken-4 font-weight-bold">1.
                                                    {{ labelStep1.D001 }}<span class="red--text"><strong>*
                                                        </strong></span></v-card-title>
                                                <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                    pdf, jpeg, jpg (Max:
                                                    2Mb)</v-card-subtitle>
                                                <v-container>
                                                    <v-file-input @change="onFileInputStep1($event, 'KHS')" show-size
                                                        placeholder="Upload your documents" :label="this.$t('unggah')"
                                                        multiple prepend-icon="mdi-file"
                                                        :disabled="kp !== null && kp !== null && kp.level_aproval_sekarang > 3">
                                                        <template v-slot:selection="{ text }">
                                                            <v-chip small label color="primary">
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                    </v-file-input>
                                                </v-container>
                                                <v-card-text class="pb-0">
                                                    <v-row v-if="step1Document['D001'].length > 0" class="mb-3">
                                                        <v-col col="12" md="12" class="py-0"
                                                            v-for="( docd001, idx ) in  step1Document.D001 "
                                                            v-bind:key="docd001.id">
                                                            <v-alert dense class="rounded-lg mb-2" color="grey lighten-3"
                                                                elevation="0">
                                                                <div class="d-flex justify-space-between">
                                                                    <h6 class="text-body-2 mb-0">
                                                                        {{ docd001.nama_dokumen }}
                                                                        <p class="text-caption text-muted mb-0"> {{
                                                                            docd001.created_at ?
                                                                            $dates.dateNoDayWithTime(docd001.created_at) :
                                                                            '' }}
                                                                        </p>
                                                                    </h6>
                                                                    <a style="text-decoration:none;" :href="docd001.url"
                                                                        target="_blank">
                                                                        <v-icon>mdi-eye</v-icon>
                                                                    </a>
                                                                </div>
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-card elevation="0" class="rounded-xl">
                                                <v-card-title
                                                    class="text-body-1 indigo--text text--darken-4 font-weight-bold">2.
                                                    {{ labelStep1.D002 }}<span class="red--text"><strong>*
                                                        </strong></span></v-card-title>
                                                <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                    pdf, jpeg, jpg (Max:
                                                    2Mb)</v-card-subtitle>
                                                <v-container>
                                                    <v-file-input @change="onFileInputStep1($event, 'BBYR')" show-size
                                                        placeholder="Upload your documents" :label="this.$t('unggah')"
                                                        multiple
                                                        :disabled="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                        prepend-icon="mdi-file">
                                                        <template v-slot:selection="{ text }">
                                                            <v-chip small label color="primary">
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                    </v-file-input>
                                                </v-container>
                                                <v-card-text class="pb-0">
                                                    <v-row v-if="step1Document['D002'].length > 0" class="mb-3">
                                                        <v-col col="12" md="12" class="py-0"
                                                            v-for="( docd002, idx ) in  step1Document['D002']"
                                                            v-bind:key="docd002.id">
                                                            <v-alert dense class="rounded-lg mb-2" color="grey lighten-3"
                                                                elevation="0">
                                                                <div class="d-flex justify-space-between">
                                                                    <h6 class="text-body-2 mb-0">
                                                                        {{ docd002.nama_dokumen }}
                                                                        <p class="text-caption text-muted mb-0"> {{
                                                                            $dates.dateNoDayWithTime(docd002.created_at) }}
                                                                        </p>
                                                                    </h6>
                                                                    <a style="text-decoration:none;" :href="docd002.url"
                                                                        target="_blank">
                                                                        <v-icon>mdi-eye</v-icon>
                                                                    </a>
                                                                </div>
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" v-if="$isFTI">
                                            <v-card elevation="0" class="rounded-xl">
                                                <v-card-title
                                                    class="text-body-1 indigo--text text--darken-4 font-weight-bold">3.
                                                    {{ labelStep1.D003 }}</v-card-title>
                                                <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                    pdf, jpeg, jpg (Max:
                                                    2Mb)</v-card-subtitle>
                                                <v-container>
                                                    <v-file-input @change="onFileInputStep1($event, 'PRPS')" show-size
                                                        placeholder="Upload your documents" :label="this.$t('unggah')"
                                                        multiple
                                                        :disabled="kp !== null && kp !== null && kp.level_aproval_sekarang > 3"
                                                        prepend-icon="mdi-file">
                                                        <template v-slot:selection="{ text }">
                                                            <v-chip small label color="primary">
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                    </v-file-input>
                                                </v-container>
                                                <v-card-text class="pb-0">
                                                    <v-row v-if="step1Document['D003'].length > 0" class="mb-3">
                                                        <v-col col="12" md="12" class="py-0"
                                                            v-for="( docd003, idx ) in  step1Document['D003']"
                                                            v-bind:key="docd003.id">
                                                            <v-alert dense class="rounded-lg mb-2" color="grey lighten-3"
                                                                elevation="0">
                                                                <div class="d-flex justify-space-between">
                                                                    <h6 class="text-body-2 mb-0">
                                                                        {{ docd003.nama_dokumen }}
                                                                        <p class="text-caption text-muted mb-0"> {{
                                                                            $dates.dateNoDayWithTime(docd003.created_at) }}
                                                                        </p>
                                                                    </h6>
                                                                    <a style="text-decoration:none;" :href="docd003.url"
                                                                        target="_blank">
                                                                        <v-icon>mdi-eye</v-icon>
                                                                    </a>
                                                                </div>
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                        <v-btn color="primary" outlined @click="buttonBackClick()">
                            Kembali
                        </v-btn>
                        <v-btn color="primary" :disabled="isLoading"
                            v-if="kp == null || ((kp !== null && kp !== null && kp.level_aproval_sekarang == 1) || (kp !== null && kp !== null && kp.level_aproval_sekarang == 3))"
                            @click="onDialogOpen(1)">
                            <v-progress-circular v-if="isLoading && stepDialog === 1" indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                            {{ (isLoading && stepDialog === 1) ? 'Loading...' : (FORM_STATUS == 'create' ? 'Simpan' : 'Ubah') }}
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="2" @click="stepChecker(2)" :complete="2 < stepActive" style="cursor: pointer;">
                        Unggah Surat Balasan
                        <small>Realisasi mulai KP, Surat balasan</small>
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <v-alert
                            v-if="kp !== null && kp !== null && kp.level_aproval_sekarang == 4 && (riwayat.length > 0 && riwayat[0].kode_status == 'SBPP')"
                            border="left" color="red lighten-2" dark>
                            <div>
                                <h6 class="text-body-1"><strong>Perlu perbaikan</strong></h6>
                                <p class="text-caption mb-1">Catatan: {{ kp.catatan }}</p>
                            </div>
                        </v-alert>
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <v-form ref="form2" v-model="approveCompany" lazy-validation>
                                    <v-card class="p-3 mb-3 indigo lighten-5" v-if="kp !== null">
                                        Surat pengantar ke perusahaan sudah tersedia.
                                        <p class="text-caption">Unduh <strong>Surat pengantar</strong> ke perusahaan, dan
                                            tunggu surat balasan. <strong>Surat balasan diterima</strong>
                                            perusahaan diperlukan untuk melanjutkan kp.</p>
                                        <v-row>
                                            <a :href="urlCetakSuratPengantar()">
                                                <v-col cols="12" md="6" sm="12" class="pb-0">
                                                    <v-alert dense right outlined color="blue darken-4"
                                                        icon="mdi-file-download"
                                                        class="card-file-download rounded-lg d-flex align-self-end">
                                                        <p class="m-0">pengantar_perusahaan.pdf</p>
                                                    </v-alert>
                                                </v-col>
                                            </a>
                                        </v-row>
                                    </v-card>
                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Isian<v-icon
                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-radio-group :disabled="kp !== null && kp.level_aproval_sekarang > 6"
                                                v-model="step2Form.kode_jenis_surat">
                                                <template #label>
                                                    Balasan perusahaan<span class="red--text"><strong>*
                                                        </strong></span>
                                                </template>
                                                <v-radio label="Ditolak perusahaan" value="SDTL"></v-radio>
                                                <v-radio label="Diterima perusahaan" value="SDTR"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6" v-if="step2Form.kode_jenis_surat == 'SDTR'">
                                            <v-menu ref="datePicker2" v-model="datePicker2" :close-on-content-click="false"
                                                :return-value.sync="date" transition="scale-transition" offset-y
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="format_tanggal_realisasi_mulai_kp"
                                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                                        <template #label>
                                                            Realisasi tanggal mulai KP<span class="red--text"><strong>*
                                                                </strong></span>
                                                        </template></v-text-field>
                                                </template>
                                                <v-date-picker v-model="step2Form.tanggal_realisasi_mulai_kp"
                                                    :readonly="kp !== null && kp.level_aproval_sekarang > 6" no-title
                                                    scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="datePicker2 = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text color="primary"
                                                        @click="$refs.datePicker2.save(step2Form.tanggal_realisasi_mulai_kp)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" v-if="step2Form.kode_jenis_surat == 'SDTR'">
                                            <v-menu ref="datePicker2b" v-model="datePicker2b"
                                                :close-on-content-click="false" :return-value.sync="date"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="format_tanggal_realisasi_selesai_kp_step2"
                                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                                        <template #label>
                                                            Realisasi tanggal selesai KP
                                                        </template></v-text-field>
                                                </template>
                                                <v-date-picker v-model="step2Form.tanggal_realisasi_selesai_kp"
                                                    :readonly="kp !== null && kp.level_aproval_sekarang > 6" no-title
                                                    scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="datePicker2b = false">
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn text color="primary"
                                                        @click="$refs.datePicker2b.save(step2Form.tanggal_realisasi_selesai_kp)">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-card elevation="0" class="rounded-xl">
                                                <v-card-title
                                                    class="text-body-1 indigo--text text--darken-4 font-weight-bold">
                                                    Surat balasan dari perusahaan<span class="red--text"><strong>*
                                                        </strong></span></v-card-title>
                                                <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                    pdf (Max:
                                                    2mb)</v-card-subtitle>
                                                <v-container>
                                                    <v-file-input @change="onFileInputStep2($event)" show-size
                                                        :disabled="kp !== null && kp.level_aproval_sekarang > 6"
                                                        placeholder="Upload your documents" :label="this.$t('unggah')"
                                                        multiple prepend-icon="mdi-file">
                                                        <template v-slot:selection="{ text }">
                                                            <v-chip small label color="primary">
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                    </v-file-input>
                                                </v-container>
                                                <v-card-text class="pb-0">
                                                    <v-row v-if="kp !== null && kp.surat_balasan.url !== null" class="mb-3">
                                                        <v-col col="12" md="12" class="py-0">
                                                            <v-alert dense class="rounded-lg mb-2" color="grey lighten-3"
                                                                elevation="0">
                                                                <div class="d-flex justify-space-between">
                                                                    <h6 class="text-body-2 mb-0">
                                                                        {{ kp.surat_balasan.jenis_surat.jenis_surat ||
                                                                            '' }}
                                                                        <p class="text-caption text-muted mb-0"> {{
                                                                            $dates.dateNoDayWithTime(kp.surat_balasan.created_at)
                                                                        }}
                                                                        </p>
                                                                    </h6>
                                                                    <a style="text-decoration:none;"
                                                                        :href="kp.surat_balasan.url" target="_blank">
                                                                        <v-icon>mdi-eye</v-icon>
                                                                    </a>
                                                                </div>
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                        <v-btn color="primary" outlined @click="buttonBackClick()">
                            Kembali
                        </v-btn>
                        <v-btn :disabled="isLoading" v-if="kp !== null && kp.level_aproval_sekarang < 6" color="primary"
                            @click="onDialogOpen(2)">
                            <v-progress-circular v-if="isLoading && stepDialog === 2" indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                            {{ (isLoading && stepDialog === 2) ? 'Loading...' : (FORM_STATUS == 'create' ? 'Simpan' : 'Perbaiki') }}
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="3" @click="stepChecker(3)" :complete="3 < stepActive" style="cursor: pointer;">
                        Unggah Laporan KP
                        <small>Laporan KP, Logbook Kegiatan, Lembar penilaian</small>
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-container class="p-4">
                                <v-card text class="p-3 mb-5 rounded-lg indigo lighten-5">
                                    Unduh dokumen
                                    <p class="text-caption">Dokumen tersebut akan digunakan untuk syarat selesai KP.</p>
                                    <v-row>
                                        <v-col cols="12" md="6" sm="12" class="pb-0" v-if="$isFTSP && this.kp">
                                            <a :href="urlCetakSuratKonfirmasi()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">konfirmasi_penerimaan.pdf</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarPenilaianPembimbing()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">lembar_penilaian.pdf</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarKonsultasi()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">lembar_konsultasi.pdf</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                        <v-col cols="12" md="6" sm="12" class="pb-0">
                                            <a :href="$unduh.lembarKegiatan()">
                                                <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                                    class="card-file-download rounded-lg d-flex align-self-end">
                                                    <p class="m-0">logbook_kegiatan.pdf</p>
                                                </v-alert>
                                            </a>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                        class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                <v-alert dense type="info" class="rounded-lg" text> <span
                                        class="grey--text text--darken-4 ">
                                        Semua dokumen bersifat <strong>wajib</strong>, dan bisa diunggah secara
                                        <strong>bertahap.</strong><br>
                                        <small><strong>Lengkapi semua dokumen untuk menyelesaikan Kerja
                                                Praktik.</strong></small>
                                    </span>
                                </v-alert>

                                <v-row>
                                    <v-col cols="12" sm="12" md="6" v-for="( doc, index ) in  step3Document "
                                        v-bind:key="doc.prop">
                                        <v-card elevation="0" class="rounded-xl" height="100%">
                                            <v-card-title
                                                class="text-body-1 indigo--text text--darken-4 font-weight-bold">{{
                                                    doc.label }}<span v-if="doc.isRequired" class="red--text"><strong>*
                                                    </strong></span></v-card-title>
                                            <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                pdf (Max:
                                                5mb)</v-card-subtitle>
                                            <v-container>
                                                <v-file-input @change="onFileInputStep3($event, doc.kode_dokumen)" show-size
                                                    placeholder="Upload your documents" :label="'Upload document'" multiple
                                                    prepend-icon="mdi-file"
                                                    :disabled="kp !== null && kp.level_aproval_sekarang > 9">
                                                    <template v-slot:selection="{ text }">
                                                        <v-chip small label color="primary">
                                                            {{ text }}
                                                        </v-chip>
                                                    </template>
                                                </v-file-input>
                                            </v-container>
                                            <v-card-text class="pb-0">
                                                <v-row v-if="doc.dokumen" class="mb-3">
                                                    <v-col col="12" md="12" class="py-0"
                                                        v-for="( label, idx ) in  doc.dokumen " v-bind:key="label.id">
                                                        <v-alert dense class="rounded-lg mb-2" color="grey lighten-3"
                                                            elevation="0">
                                                            <div class="d-flex justify-space-between">
                                                                <h6 class="text-body-2 mb-0">
                                                                    {{ label.nama_dokumen }}
                                                                    <p class="text-caption text-muted mb-0"> {{
                                                                        $dates.dateNoDayWithTime(label.created_at) }}</p>
                                                                </h6>
                                                                <a style="text-decoration:none;" :href="label.url"
                                                                    target="_blank">
                                                                    <v-icon>mdi-eye</v-icon>
                                                                </a>
                                                            </div>
                                                        </v-alert>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-btn color="primary" outlined @click="buttonBackClick()">
                            Kembali
                        </v-btn>
                        <v-btn :disabled="isLoading" v-if="kp !== null && kp.level_aproval_sekarang < 9" color="primary"
                            @click="onDialogOpen(3)">
                            <v-progress-circular v-if="isLoading && stepDialog === 3" indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                            {{ (isLoading && stepDialog === 3) ? 'Loading...' : (FORM_STATUS == 'create' ? 'Simpan' : 'Perbaiki') }}
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-step step="4" @click="stepChecker(4)" :complete="beritaAcaraExists()">
                        Selesai
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-alert v-if="beritaAcaraExists()" type="success" text dense> <strong> Kerja Praktik telah
                                selesai.</strong><br>
                            Terimakasih telah menjalankan Kerja praktik sebaik-baiknya.
                        </v-alert>
                        <v-card v-if="!beritaAcaraExists()" text class="p-3 mb-5 rounded-lg indigo lighten-5">
                            Unduh dokumen
                            <p class="text-caption">Template Berita acara seminar</p>
                            <v-row>
                                <v-col cols="12" md="6" sm="12" class="pb-0">
                                    <a :href="urlBeritaAcara()">
                                        <v-alert dense right outlined color="blue darken-4" icon="mdi-file-download"
                                            class="card-file-download rounded-lg d-flex align-self-end">
                                            <p class="m-0">berita_acara.pdf</p>
                                        </v-alert>
                                    </a>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card v-if="!beritaAcaraExists()" class="mb-12 rounded-xl grey lighten-4" elevation="0">
                            <v-form ref="form4" v-model="finishKP" lazy-validation>
                                <v-container class="p-4">
                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-card elevation="0" class="rounded-xl" height="100%">
                                                <v-card-title
                                                    class="text-body-1 indigo--text text--darken-4 font-weight-bold">Berita
                                                    acara<span class="red--text"><strong>*
                                                        </strong></span></v-card-title>
                                                <v-card-subtitle class="text-caption indigo--text text--darken-4">Format:
                                                    pdf (Max:
                                                    2mb)</v-card-subtitle>
                                                <v-container>
                                                    <v-file-input @change="onFileInputStep4($event)" show-size
                                                        placeholder="Unggah dokumen" :label="this.$t('unggah')" multiple
                                                        prepend-icon="mdi-file">
                                                        <template v-slot:selection="{ text }">
                                                            <v-chip small label color="primary">
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                    </v-file-input>
                                                </v-container>
                                            </v-card>
                                        </v-col>
                                        <!-- <v-col cols="12" sm="12" md="6">
                                        <v-menu ref="datePicker4" v-model="datePicker4" :close-on-content-click="false"
                                            :return-value.sync="step4Form.tanggal_realisasi_selesai_kp"
                                            transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="format_tanggal_realisasi_selesai_kp"
                                                    :rules="$rules.required" append-icon="mdi-calendar" readonly
                                                    v-bind="attrs" v-on="on">
                                                    <template #label>
                                                        Realisasi selesai KP<span class="red--text"><strong>*
                                                            </strong></span>
                                                    </template>
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="step4Form.tanggal_realisasi_selesai_kp" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="datePicker4 = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary"
                                                    @click="$refs.datePicker4.save(step4Form.tanggal_realisasi_selesai_kp)">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col> -->
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-card>
                        <v-btn color="primary" outlined @click="buttonBackClick()">
                            Kembali
                        </v-btn>
                        <v-btn :disabled="isLoading"
                            v-if="!beritaAcaraExists() && kp !== null && kp.level_aproval_sekarang <= 11" color="primary"
                            @click="onDialogOpen(4)">
                            <v-progress-circular v-if="isLoading && stepDialog === 4" indeterminate size="20" width="2" class="mr-2"></v-progress-circular>
                            {{ (isLoading && stepDialog === 4) ? 'Loading...' : (FORM_STATUS == 'create' ? 'Simpan' : 'Perbaiki') }}
                        </v-btn>
                    </v-stepper-content>
                </v-stepper>
            </template>
        </v-container>
    </v-row>
</template>

<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            user: JSON.parse(localStorage.getItem("user")),
            stepDialog: null,
            dialog: false,
            riwayat: [],
            input: undefined,
            values: undefined,
            userData: null,
            kp: null,
            currentDate: new Date().toISOString().slice(0, 10),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            datePicker1: false,
            datePicker1b: false,
            datePicker2: false,
            datePicker2b: false,
            datePicker4: false,
            tabs: null,
            FORM_STATUS: "create",
            step: 1,
            stepActive: null,
            isLoading: false,
            register: true,
            finishKP: true,
            selectedValue: '',
            approveCompany: true,
            kuliah_prasyarat: [],
            master_kuliah_prasyarat: [],
            labelStep1: {
                tanggal_rencana_mulai_kp: this.$t('tanggal_rencana_mulai_kp'),
                tanggal_rencana_selesai_kp: this.$t('tanggal_rencana_selesai_kp'),
                perusahaan_tujuan: this.$t('perusahaan_tujuan'),
                alamat_perusahaan: this.$t('alamat_perusahaan'),
                kuliah_prasyarat: this.$t('kuliah_prasyarat'),
                kategori_perusahaan: this.$t('kategori_perusahaan'),
                bidang_topik: this.$t('bidang_topik'),
                D001: this.$t('D001'),
                D002: this.$t('D002'),
                D003: this.$t('D003'),
            },
            step1Form: {
                tanggal_rencana_mulai_kp: null,
                tanggal_rencana_selesai_kp: null,
                perusahaan_tujuan: undefined,
                alamat_perusahaan: undefined,
                bidang_topik: undefined,
                ipk: null,
                sks: null,
                no_hp: null,
                dokumen: {
                    D001: undefined,
                    D002: undefined,
                    D003: undefined,
                },
                company_type_id: null,
                company_topic_id: null,
            },
            step1Document: {
                D001: [],
                D002: [],
                D003: [],
            },
            step2Form: {
                kp_id: undefined,
                tanggal_realisasi_mulai_kp: undefined,
                tanggal_realisasi_selesai_kp: undefined,
                kode_jenis_surat: undefined,
                dokumen: undefined,
            },
            step3Form: {
                dokumen: {
                    D004: undefined,
                    D005: undefined,
                    D006: undefined,
                    D008: undefined,
                    D009: undefined,
                }
            },
            step4Form: {
                berita_acara: undefined,
                tanggal_realisasi_selesai_kp: undefined
            },
            step3Document: [],
            selectOptions: {
                scientific_fields: [],
                scientific_field_users: [],
                first_supervisors: [],
                second_supervisors: [],
                users: [],
                projects: [],
                company_type: [],
                company_topics: [],
            },
        }
    }, 
    created() {
        if (this.$route.query.update) {
            this.FORM_STATUS = 'update';
        }

        this.getStep3Document();
        this.getData();
        this.getMasterMatakuliah();
        this.getCompanyType();
        this.getCompanyTopics();
    },
    computed: {
        format_tanggal_rencana_selesai_kp() {
            return this.formatDate(this.step1Form.tanggal_rencana_selesai_kp);
        },
        format_tanggal_rencana_mulai_kp() {
            return this.formatDate(this.step1Form.tanggal_rencana_mulai_kp);
        },
        format_tanggal_realisasi_mulai_kp() {
            return this.formatDate(this.step2Form.tanggal_realisasi_mulai_kp);
        },
        format_tanggal_realisasi_selesai_kp_step2() {
            return this.formatDate(this.step2Form.tanggal_realisasi_selesai_kp);
        },
        format_tanggal_realisasi_selesai_kp() {
            return this.formatDate(this.step4Form.tanggal_realisasi_selesai_kp);
        }
    },
    watch: {
        'step2Form.kode_jenis_surat'(newValue) {
            if (newValue == 'SDTL') this.step2Form.tanggal_realisasi_mulai_kp = undefined;
        },
    },
    methods: {
        getStep3Document() {
            let document = [
                {
                    label: 'Lembar Konsultasi',
                    kode_dokumen: 'D004',
                    prop: 'LKSL',
                    isRequired: true,
                    dokumen: []
                },
                {
                    label: 'Logbook Kegiatan',
                    kode_dokumen: 'D005',
                    isRequired: true,
                    dokumen: [],
                    prop: 'LKGT',
                },
                {
                    label: 'Lembar Penilaian Pembimbing KP',
                    kode_dokumen: 'D006',
                    isRequired: true,
                    dokumen: [],
                    prop: 'LPNL'
                },
                {
                    label: 'Laporan Final Kerja praktik',
                    kode_dokumen: 'D007',
                    prop: 'LPRN',
                    isRequired: true,
                    dokumen: []
                },
            ];

            if (process.env.MIX_FACULTY_LABEL == 'FTSP') {
                document.push({
                    label: 'Surat konfirmasi penerimaan',
                    kode_dokumen: 'D009',
                    prop: 'SKPN',
                    isRequired: true,
                    dokumen: []
                });
            }

            this.step3Document = document;
        },
        urlCetakSuratKonfirmasi() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-konfirmasi';
        },
        getCompanyTopics() {
            this.axios.get("/api/master/company-topics").then((res) => {
                this.selectOptions.company_topics = res.data.data;
            })
                .catch((err) => console.log(err, 'err'))
        },
        getCompanyType() {
            this.axios.get("/api/master/company-type").then((res) => {
                this.selectOptions.company_type = res.data.data;
            })
                .catch((err) => console.log(err, 'err'))
        },
        getData() {
            this.axios.get("/api/mahasiswa/kp").then((res) => {
                this.userData = res.data.data;
                this.kp = this.userData.kp;
                this.laporanDistribution();
                if (this.kp !== null && this.kp.level_aproval_sekarang >= 1) {
                    this.getStep1Data();
                } if (this.kp !== null && this.kp.level_aproval_sekarang >= 4) {
                    this.getStep2Data();
                } if (this.kp !== null && this.kp.level_aproval_sekarang >= 7) {

                }
            })
                .catch((err) => console.log(err, 'err'))
                .finally(() => {
                    this.checkingKP();
                    if (this.kp !== null) this.getRiwayat();
                });
        },
        getRiwayat() {
            this.axios.get("/api/kp/" + this.kp.id + '/riwayat').then((res) => {
                this.riwayat = res.data.data.sort();
                if (this.riwayat) {
                    this.riwayat = this.riwayat.map(val => {
                        val.time = new Date(val.created_at).getHours() + ':' + new Date(val.created_at).getMinutes();
                        val.date = new Date(val.created_at).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
                        return val;
                    }).sort(function (a, b) {
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at);
                        // Compare the 2 dates
                        if (keyA < keyB) return 1;
                        if (keyA > keyB) return -1;
                        return 0;
                    });
                }
            })
                .catch((err) => this.riwayat = null)
                .finally(() => console.log('riwayat->loaded'));
        },
        getMasterMatakuliah() {
            this.axios.get("/api/kp/matakuliah").then((res) => {
                this.master_kuliah_prasyarat = res.data.data;
            })
                .catch((err) => console.log(err, 'err'))
                .finally(() => this.checkingKP());
        },
        formatDate(date) {
            if (!date) return null

            const dates = new Date(date).toLocaleDateString('id-ID', { month: 'long', year: 'numeric', day: 'numeric' });
            return dates;
        },
        onKeydown(event) {
            let same = this.master_kuliah_prasyarat.find(val => val.matakuliah == this.input);
            if (this.input && !same) {
                if (event.code == 'Enter') {
                    this.kuliah_prasyarat.push({
                        matakuliah: this.input,
                        id: ''
                    });
                    this.master_kuliah_prasyarat.push({
                        matakuliah: this.input,
                        id: ''
                    });
                    this.input = '';
                    console.log(this.kuliah_prasyarat, 'kuliah_prasyarat');
                }
            } else if (this.input && same) {
                if (this.kuliah_prasyarat.find(val => val.name == this.input)) this.kuliah_prasyarat.push(same);
                this.input = '';
            }
        },
        onBlurMatakuliah(event) {
            if (this.input && !this.master_kuliah_prasyarat.find(val => val.matakuliah == this.input)) {
                this.kuliah_prasyarat.push({
                    matakuliah: this.input,
                    id: ''
                });
                this.master_kuliah_prasyarat.push({
                    matakuliah: this.input,
                    id: ''
                });
                this.input = '';
            }
        },
        getStep1Data() {
            this.step1Form.ipk = this.kp.ipk;
            this.step1Form.no_hp = this.userData.no_hp;
            this.step1Form.sks = this.kp.sks;
            this.step1Form.tanggal_rencana_mulai_kp = this.kp.tanggal_rencana_mulai_kp;
            this.step1Form.tanggal_rencana_selesai_kp = this.kp.tanggal_rencana_selesai_kp;
            this.step1Form.perusahaan_tujuan = this.kp.perusahaan_tujuan;
            this.step1Form.alamat_perusahaan = this.kp.alamat_perusahaan;
            this.step1Form.company_type_id = this.kp.kategori_perusahaan.id;
            this.step1Form.company_topic_id = this.kp.bidang_topik.id;
            this.kuliah_prasyarat = this.kp.matakuliah_prasyarat;
            this.kp.dokumen.forEach(el => {
                if (el.kode_jenis_dokumen == 'D001') {
                    this.step1Document['D001'] = el.dokumen
                } else if (el.kode_jenis_dokumen == 'D002') {
                    this.step1Document['D002'] = el.dokumen
                } else if (el.kode_jenis_dokumen == 'D003') {
                    this.step1Document['D003'] = el.dokumen
                }
            })
            console.log(this.step1Document['D003']);
        },
        getStep2Data() {
            this.step2Form.tanggal_realisasi_mulai_kp = this.kp.tanggal_realisasi_mulai_kp;
            this.step2Form.tanggal_realisasi_selesai_kp = this.kp.tanggal_realisasi_selesai_kp;
            this.step2Form.kode_jenis_surat = this.kp.surat_balasan.jenis_surat.kode_jenis_surat;
        },
        checkingKP() {
            if (this.kp == null) {
                this.stepActive = 1;
                console.log(this.stepActive, 'stepActiveCheck');
            } else if (this.kp !== null && this.kp.level_aproval_sekarang == 4) {
                this.step = 2;
                this.stepActive = 2;
                console.log(this.stepActive, 'stepActiveCheck');
            } else if (this.kp !== null && this.kp.level_aproval_sekarang == 7) {
                this.step = 3;
                this.stepActive = 3;
                console.log(this.stepActive, 'stepActiveCheck');
            } else if (this.kp !== null && this.kp.level_aproval_sekarang >= 10 && this.kp.nilai_angka != null) {
                this.step = 4;
                this.stepActive = 4;
                console.log(this.stepActive, 'stepActiveCheck');
            }
        },
        onDialogOpen(step) {
            this.dialog = true;
            this.stepDialog = step;
        },
        async onCloseDialog(event) {
            if (event == true) {
                // Set loading state saat tombol Simpan diklik
                this.isLoading = true;
                
                // Tunggu sebentar agar loading text terlihat
                await this.$nextTick();
                
                switch (this.stepDialog) {
                    case 1:
                        await this.submitStep1();
                        break;
                    case 2:
                        await this.submitStep2();
                        break;
                    case 3:
                        await this.submitStep3();
                        break;
                    case 4:
                        await this.submitStep4();
                        break;
                    default:
                        break;
                }
                
                // Dialog akan ditutup setelah submit selesai
                this.dialog = false;
            } else {
                // Reset loading state jika dialog ditutup dengan Batal
                this.isLoading = false;
                this.dialog = false;
            }
        },
        beritaAcaraExists() {
            if (this.$isFTSP) return true;

            let exist = false;
            if (this.kp !== null) {
                exist = this.kp.laporan.find(x => x.kode_jenis_dokumen == 'D008').dokumen.length > 0;
                return exist;
            }
        },
        urlBeritaAcara() {
            return this.$baseurl + '/api/cetak/berita-acara';
        },
        submitStep1() {
            const valid = this.$refs.form1.validate();
            if (!valid) {
                this.isLoading = false; // Reset loading jika validasi gagal
                return;
            }
            
            let url = "/api/mahasiswa/kp";
            
            const options = {
                indices: false,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            };
            
            if (this.FORM_STATUS === "update") {
                this.step1Form["_method"] = "put";
                url = "/api/mahasiswa/kp/" + this.$route.query.update;
            }
            
            let formData = new FormData();
            formData = serialize(this.step1Form, options);
            this.kuliah_prasyarat.forEach((val, index) => {
                formData.append('matakuliah[' + index + '][nama]', val.matakuliah);
                formData.append('matakuliah[' + index + '][id]', val.id);
            });

            this.axios
                .post(url, formData)
                .then((res) => {
                    this.$emit("toast", "success", "Berhasil menyimpan data");
                    this.$router.push({ name: "home" });
                })
                .catch((err) => {
                    console.error('Error submitting step 1:', err);
                    this.$emit("toast", "error", "Gagal menyimpan data");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        submitStep2() {
            const valid = this.$refs.form2.validate();
            if (!valid) {
                this.isLoading = false; // Reset loading jika validasi gagal
                return;
            }
            
            let url = "/api/mahasiswa/surat-balasan";
            const options = {
                indices: false,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            };
            let formData = new FormData();
            formData = serialize(this.step2Form, options);
            this.axios
                .post(url, formData)
                .then((res) => {
                    this.$emit("toast", "success", res.data.message);
                    this.$router.push({ name: "home" });
                })
                .catch((err) => {
                    console.error('Error submitting step 2:', err);
                    this.$emit("toast", "error", "Gagal menyimpan data");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        submitStep3() {
            const valid = this.$refs.form2.validate();
            if (!valid) {
                this.isLoading = false; // Reset loading jika validasi gagal
                return;
            }
            
            let url = "/api/mahasiswa/kp/" + this.kp.id + "/laporan";
            const options = {
                indices: false,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            };
            let formData = new FormData();
            formData = serialize(this.step3Form, options);
            formData.append('kp_id', this.kp.id);
            this.axios
                .post(url, formData)
                .then((res) => {
                    this.$emit("toast", "success", res.data.message);
                    this.$router.push({ name: "home" });
                })
                .catch((err) => {
                    console.error('Error submitting step 3:', err);
                    this.$emit("toast", "error", "Gagal menyimpan data");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        submitStep4() {
            const valid = this.$refs.form4.validate();
            if (!valid) {
                this.isLoading = false; // Reset loading jika validasi gagal
                return;
            }
            
            let url = "/api/kp/" + this.kp.id + "/dokumen/berita-acara";
            const options = {
                indices: false,
                nullsAsUndefineds: false,
                booleansAsIntegers: false,
                allowEmptyArrays: false,
                noFilesWithArrayNotation: false,
                dotsForObjectNotation: false,
            };
            let formData = new FormData();
            formData = serialize(this.step4Form, options);
            formData.append('kp_id', this.kp.id);
            this.axios
                .post(url, formData)
                .then((res) => {
                    this.$emit("toast", "success", res.data.message);
                    this.$router.push({ name: "home" });
                })
                .catch((err) => {
                    console.error('Error submitting step 4:', err);
                    this.$emit("toast", "error", "Gagal menyimpan data");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onFileInputStep1(file, type) {
            if (file.length !== 0) {
                switch (type) {
                    case 'KHS':
                        this.step1Form.dokumen['D001'] = file[0];
                        break;
                    case 'BBYR':
                        this.step1Form.dokumen['D002'] = file[0];
                        break;
                    case 'PRPS':
                        this.step1Form.dokumen['D003'] = file[0];
                        break;
                    default:
                        break;
                }
            } else {
                switch (type) {
                    case 'KHS':
                        this.step1Form.dokumen['D001'] = null;
                        break;
                    case 'BBYR':
                        this.step1Form.dokumen['D002'] = null;
                        break;
                    case 'PRPS':
                        this.step1Form.dokumen['D003'] = null;
                        break;
                    default:
                        break;
                }
            }
        },
        onFileInputStep3(file, type) {
            if (file.length !== 0) {
                this.step3Form.dokumen[type] = file[0];
            } else {
                this.step3Form.dokumen[type] = null;
            }
            console.log(this.step3Form.dokumen);
        },
        onFileInputStep4(file) {
            if (file.length !== 0) {
                this.step4Form.berita_acara = file[0];
            } else {
                this.step3Form.berita_acara = null;
            }
            console.log(this.step3Form.dokumen);
        },
        onChangeMatakulah(event) {
            console.log(event, 'eventt22');
        },
        onFileInputStep2(file, type) {
            this.step2Form.kp_id = this.kp.id;
            this.step2Form.dokumen = file[0];
        },
        urlCetakSuratPengantar() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-pengantar';
        },
        buttonBackClick() {
            this.$router.push({ name: "home" });
        },
        laporanDistribution() {
            if (this.kp !== null) {
                this.step3Document.forEach(val => {
                    let item = this.kp.laporan.find(item => item.kode_jenis_dokumen == val.kode_dokumen);
                    if (item) {
                        val.dokumen = item.dokumen;
                    }
                });
            }
        },
        stepChecker(step) {
            if (step <= this.stepActive) {
                this.step = step;
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
<style>
.card-file-download {
    font-size: calc(0.5em + 1vmin);
    cursor: pointer;

}

a {
    text-decoration: none;
}

.card-file-download:hover {
    transform: scale(1.02);
    opacity: 0.5;
}

@media only screen and (max-width: 600px) {
    .card-file-download {
        font-size: calc(0.3em + 1vmin);
    }
}
</style>